export default "__VITE_ASSET__Cg1JYVCk__"